import { ComposableSearchDropdown, ComposableSearchDropdownProps } from "@themuse/design-system";
import { IndexedObject } from "@themuse/design-system/lib/components/Dropdowns/ComposableDropdown/DropdownProvider";
import { LocationShape } from "@themuse/design-system/lib/components/Icons";
import { UseComboboxStateChange } from "downshift"; // eslint-disable-line import/no-extraneous-dependencies
import React from "react";
import { SearchLocation } from "interfaces/context/searchContextInterfaces";
import homeStyles from "styles/Home.module.scss";
import { suggestionApiQueryMaxlength } from "utils/constants";
import styles from "./SearchInput.module.scss";

interface SearchInputFieldProps {
    clear?: boolean;
    onClear?: () => void;
}

interface LocationSearchFieldProps extends SearchInputFieldProps {
    location: SearchLocation;
    onInputChange: (changes: UseComboboxStateChange<IndexedObject>) => void;
    noResultsMessage: React.ReactNode;
}

const menuToggle = (value: boolean) => {
    const navHeader = document.querySelectorAll("header[class^='Header_header']");

    navHeader.forEach((elem) => {
        if (value) {
            elem.classList.add(homeStyles.inputMenuOpen);
        } else {
            elem.classList.remove(homeStyles.inputMenuOpen);
        }
    });
};

const filterList = (list: IndexedObject[], value = "") => list.filter(
    (item: IndexedObject) => item?.label?.toLowerCase().includes(value?.toLowerCase())
);

const LocationSearchInput = (props: LocationSearchFieldProps) => {
    const {
        location, clear, onClear, onInputChange, noResultsMessage
    } = props;
    const { locationSuggestions, userSelectedLocation, userInputValue } = location;
    const placeHolderText = "Anywhere";
    const dropdownProps: ComposableSearchDropdownProps = {
        classes: {
            container: styles.searchInputContainer,
            inputIcon: styles.inputIcon
        },
        dropdownProps: {
            dropdownList: filterList(locationSuggestions, userInputValue),
            IconComponent: <LocationShape />,
            dropdownTitle: "Type to select a location",
            debounceWait: 200,
            labelText: "Locations",
            placeHolderText,
            inputId: "location-input",
            maxLength: suggestionApiQueryMaxlength,
            onInputChange,
            onMenuToggle: menuToggle,
            clearValue: clear,
            onClear,
            fieldValue: userSelectedLocation,
            showMenuOnFocus: true,
            refocusMobileOnClear: true,
            noResultsMessage
        }
    };

    return <ComposableSearchDropdown {...dropdownProps} />;
};

LocationSearchInput.displayName = "LocationSearchInput";
export default LocationSearchInput;
